import './live-accordion.css';

import { DsIcon } from '@descomplica/design-system-react';
import { observer, useViewModel } from '@descomplica/microfrontend-react';
import React, { useEffect, useState } from 'react';

import { LiveStatus } from '@/application/commons/enums/live.enum';
import { ClassroomViewModel, Lesson } from '@/presentation/screens/classroom/classroom.vm';
import { ButtonContainer } from '@/presentation/shared-components/button';
import { LessonTitle } from '@/presentation/shared-components/text';

import LessonExercise from '../lesson-accordion/exercise';
import SupportMaterialLink from '../lesson-accordion/support-material-link';
import LiveContent from './live-content';

type LiveAccordionParams = {
  live: Lesson;
};

const LiveAccordionContainer = ({ live }: LiveAccordionParams) => {
  const vm = useViewModel(ClassroomViewModel);
  const [open, setOpen] = useState(false);
  const toggleLive = () => setOpen(!open);
  const handleClick = () => toggleLive();
  const isScheduledLive = live.streaming.lessonStatus === LiveStatus.NEXT;

  useEffect(() => {
    setOpen(live.streaming?.guid === vm.currentLesson?.streaming?.guid);
  }, [vm.currentLesson]);
  return (
    <>
      <li>
        <ButtonContainer
          className={`${open ? 'live-button opened-lesson' : 'live-button'}`}
          onClick={handleClick}
          ariaLabel={`${open ? 'Fechar atividades da aula' : `Ver atividades live`}`}
        >
          <div className="live-description">
            <div className="live-teacher">
              <LessonTitle className="live-title">{live.name}</LessonTitle>
              <div className="live-info-wrapper">
                <DsIcon color="gray-dark" image={open ? 'arrow-drop-up' : 'arrow-drop-down'} />
              </div>
            </div>
          </div>
        </ButtonContainer>
        <div className={`live-data ${open ? 'show' : 'hide'}`}>
          <div>
            <p className="notice-of-non-mandatory-content">
              As aulas ao vivo não são obrigatórias para a geração do micro-certificado e o seu
              progresso no curso.
            </p>
          </div>
          <div className="live-contents">
            {open && <LiveContent lesson={live} isScheduledLive={isScheduledLive} />}
          </div>
          {open && live?.exercises.length > 0
            ? live?.exercises.map((exercise) => (
                <LessonExercise
                  key={live.guid}
                  classroom={vm.classroom}
                  lesson={live}
                  url={`/answer/${exercise.guid}/lesson/${exercise.lessonGuid}`}
                  label="Exercício"
                  exercise={{ lesson_guid: exercise.lessonGuid, exercises_guid: exercise.guid }}
                  openExercise={vm.setHasExerciseOpen}
                />
              ))
            : null}
          {live.supportMaterial?.url && (
            <SupportMaterialLink
              classroom={vm.classroom}
              lesson={live}
              supportMaterial={live.supportMaterial}
            />
          )}
        </div>
      </li>
    </>
  );
};

export default observer(LiveAccordionContainer);
